import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import {
  AppBar,
  Box,
  Hidden,
  IconButton,
  Toolbar,
  makeStyles,
  Typography
} from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';
import Logo from 'src/components/Logo';
import navMenuItems from 'src/config/navMenuItems';
import TopMenuItem from './TopMenuItem';

const useStyles = makeStyles((theme) => ({
  root: {},
  avatar: {
    width: 60,
    height: 60
  },
  logoTitle: {
    color: theme.palette.text.white
  }
}));

const TopBar = ({
  className,
  onMobileNavOpen,
  ...rest
}) => {
  const classes = useStyles();

  return (
    <AppBar
      className={clsx(classes.root, className)}
      elevation={0}
      {...rest}
    >
      <Toolbar variant="dense">
        <RouterLink to="/">
          <Box display="flex" flexDirection="row">
            <Box>
              <Logo />
            </Box>
            <Box ml={2} />
            <Typography variant="h5" className={classes.logoTitle}>
              Stapto
            </Typography>
          </Box>
        </RouterLink>
        <Box flexGrow={1} />
        <Hidden mdDown>
          {navMenuItems.map((item) => (
            <TopMenuItem key={item.title} item={item} />
          ))}
        </Hidden>
        <Hidden lgUp>
          <IconButton
            color="inherit"
            onClick={onMobileNavOpen}
          >
            <MenuIcon />
          </IconButton>
        </Hidden>
      </Toolbar>
    </AppBar>
  );
};

TopBar.propTypes = {
  className: PropTypes.string,
  onMobileNavOpen: PropTypes.func
};

export default TopBar;
